import type { IconData } from '@stacksjs/iconify-core'

export const ye1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h512v504.3H0z\"/><path fill=\"#f10600\" d=\"M0 0h512v167.9H0z\"/><path fill=\"#000001\" d=\"M0 344.1h512V512H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ye1x1
